import { render, staticRenderFns } from "./NotificationHandler.vue?vue&type=template&id=b23e8e8e&scoped=true&"
import script from "./NotificationHandler.vue?vue&type=script&lang=js&"
export * from "./NotificationHandler.vue?vue&type=script&lang=js&"
import style0 from "./NotificationHandler.vue?vue&type=style&index=0&id=b23e8e8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23e8e8e",
  null
  
)

export default component.exports